import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import Spinner from '@/components/UI/Spinner/Spinner';
import TechAssessment from '@/containers/CampaignDetail/AffectedVehicles/TechAssessment/TechAssessment';
import { mapAggregateModelSelections } from '@/containers/CampaignDetail/AffectedVehicles/Volume/VolumeDetails/volumeDetails-utils';
import Notes from '@/containers/SubCampaignDetail/Notes/Notes';
import { TABS } from '@/helpers/constants';
import useError from '@/hooks/useError';
import { setCampaignVehicles } from '@/redux/Campaign/campaign.action';
import { getCampaignVehicles, getIsVANCR } from '@/redux/Campaign/campaign.reducer';
import { setSubCampaignOriginalValues, setSubCampaignVehiclesNotes } from '@/redux/SubCampaign/subCampaign.action';
import { getSubCampaignOriginalValues, getSubcampaignVehiclesNotes } from '@/redux/SubCampaign/subCampaign.reducer';
import { getSettingsInfo } from '@/redux/User/user.reducer';
import campaignServices from '@/services/campaignServices';
import { AffectedVehicles, OriginalValues, RouterParams } from '@/types';
import LimitationVolume from './LimitationVolume/LimitationVolume';
import RestrictionForPlants from './RestrictionForPlants/RestrictionForPlants';

interface VehiclesProps {
  setNotes: (notes: string[]) => void;
  vehiclesNotes: string[];
  affectedVehicles: AffectedVehicles;
  setAffectedVehicles: (vehicles: AffectedVehicles) => void;
  setOriginalValues: (values: OriginalValues) => void;
  originalValues: OriginalValues;
  timeZone: string;
  isVANCR: boolean;
}

const Vehicles: React.FC<VehiclesProps> = (props) => {
  const { setNotes, vehiclesNotes, affectedVehicles, setAffectedVehicles, setOriginalValues, originalValues, timeZone,
    isVANCR } = props;
  const { id, version } = useParams<RouterParams>();
  const { handleCriticalError } = useError();
  const isLoading = !affectedVehicles?.id;

  useEffect(() => {
    if (timeZone) {
      Promise.all([
        campaignServices.getSubCampaign(id, 'AFFECTED_VEHICLES', version),
        campaignServices.getSubCampaign(id, 'LIMITATION_OF_VOLUME', version),
      ]).then((res) => {
        const [affVehicles, limitationVolumes] = res;
        const newState = {
          ...affVehicles.module,
          volumes: mapAggregateModelSelections([limitationVolumes.module], timeZone),
        };
        setAffectedVehicles(newState);
      }).catch(handleCriticalError);
    }
  }, [id, version]);

  const onSetOriginValues = () => {
    const values = {
      ...originalValues,
      hasChange: true,
    };
    setOriginalValues(values);
  };

  const addNotes = () => {
    setNotes([...vehiclesNotes, '']);
  };

  const handleChangeText = (comment: string, noteId: number) => {
    const newState = [...vehiclesNotes];
    newState.splice(noteId, 1, comment);
    setNotes(newState);
    onSetOriginValues();
  };

  return (
    <>
      {isLoading && <Spinner isVisible isMask />}
      <TechAssessment />
      <RestrictionForPlants />
      <LimitationVolume />
      {!isVANCR && (<Notes notes={vehiclesNotes} addNotes={addNotes} handleChangeText={handleChangeText} tab={TABS.affectedVehicles.label} />)}
    </>
  );
};

const mapStateToProps = (state) => ({
  affectedVehicles: getCampaignVehicles(state),
  vehiclesNotes: getSubcampaignVehiclesNotes(state),
  timeZone: getSettingsInfo(state)?.timezone,
  originalValues: getSubCampaignOriginalValues(state),
  isVANCR: getIsVANCR(state),
});

const actionCreators = {
  setAffectedVehicles: setCampaignVehicles,
  setNotes: setSubCampaignVehiclesNotes,
  setOriginalValues: setSubCampaignOriginalValues,
};

export default connect(mapStateToProps, actionCreators)(Vehicles);
